export default function(o){

  var comingSoonLabel =
    o.util.getTranslation(o, 'comingSoon')

  var logoDiv =
    $('<div>')
    .css({
      fontSize: o.fontSizeDef.l,
      margin: '1rem 0',
      marginTop: '2rem',
      marginBottom: '0.5rem',
    })
    .html('open memory box')

  var comingSoonDiv =
    $('<div>')
    .css({
      textAlign: 'center',
    })
    .html(comingSoonLabel)
    .css({
      color: o.colors.red,
      fontSize: o.fontSizeDef.s,
    })

  var contactClick = function(){
    document.location.href =
      'mailto:info@open-memory-box.de'
  }
  
  var contactLabel =
    o.util.getTranslation(o, 'contact')
    
  var contactDiv =
    o.component.button(o, contactLabel, contactClick)
    
  var pressClick = function(){
    history.pushState({}, '', '/press')
    o.render(o)
  }

  var pressLabel =
    o.util.getTranslation(o, 'press')

  var pressDiv =
    o.component.button(o, pressLabel, pressClick)

  var menuDiv = $('<div>')
  .css({
    fontSize: o.fontSizeDef.s,
    marginTop: '-0.1rem',
  })
  .append([
    contactDiv,
    // pressDiv,
  ])

  var earlyAccessTitleLabel =
    o.util.getTranslation(o, 'earlyAccess')

  var earlyAccessTitleDiv =
    o.component.button(o, earlyAccessTitleLabel)

  var earlyAccessErrorLabel =
    o.util.getTranslation(o, 'wrongCode')

  var earlyAccessLogin = function(){
    if(
      earlyAccessInputDiv.val().toLowerCase() == 'ombearlyaccess' || 
      earlyAccessInputDiv.val().toLowerCase() == 'alex' || 
      earlyAccessInputDiv.val().toLowerCase() == 'ombpresslogin'
    ){
      o.store('earlyAccess', true)
      if(earlyAccessInputDiv.val().toLowerCase() == 'ombpresslogin'){
        o.store('pressAccess', true)
      }
      earlyAccessErrorDiv.html("&nbsp;")
      o.render(o)
    } else {
      earlyAccessErrorDiv.html(earlyAccessErrorLabel)
    }
  }
  
  var earlyAccessInputDiv =
    o.component.input(o)
    .attr({
      type: 'password',
    })
    .css({
      width: '10rem',
      margin: '0 auto',
    })
    .keyup(function(e) {
      if (e.keyCode === 13) {
        earlyAccessLogin()
      }
    })

  var earlyAccessLoginLabel =
    o.util.getTranslation(o, 'login')

  var earlyAccessLoginDiv =
    o.component.button(o, earlyAccessLoginLabel, earlyAccessLogin)

  var earlyAccessErrorDiv =
    $('<div>')
    .css({
      color: o.colors.red,
      fontSize: o.fontSizeDef.s,
      textTransform: 'none',
    })
    .html('&nbsp;')

  var earlyAccessDiv = $('<div>')
    .css({
      fontSize: o.fontSizeDef.s,
      marginTop: '0.8rem',
      display: 'flex',
      flexDirection: 'column',
    })
    .append([
      earlyAccessTitleDiv,
      earlyAccessInputDiv,
      earlyAccessLoginDiv,
      earlyAccessErrorDiv,
    ])

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
    })
    .append([
      logoDiv,
      comingSoonDiv,
      menuDiv,
      earlyAccessDiv,
    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/comingSoon/main/main.js